module.exports = __webpack_public_path__ + "img/happiness.a0cd36a7.svg";